import React from 'react';
import { Navigate } from 'react-router';
import { isNonProdOrigin } from '@/lib/nonProdHost';

export interface NoProdRouteProps {
    children: React.ReactNode;
}

export const NoProdRoute = ({ children }: NoProdRouteProps): React.ReactNode => {
    const origin = window.location.origin;
    const hostname = window.location.hostname;
    if (isNonProdOrigin(origin, hostname)) {
        return children;
    }
    return <Navigate to="/" replace />;
};
